import { render, staticRenderFns } from "./ClockFlip.vue?vue&type=template&id=3cf3622b&scoped=true"
import script from "./ClockFlip.vue?vue&type=script&lang=js"
export * from "./ClockFlip.vue?vue&type=script&lang=js"
import style0 from "./ClockFlip.vue?vue&type=style&index=0&id=3cf3622b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3622b",
  null
  
)

export default component.exports